import React, { useState } from 'react';
import { MessageSquareIcon } from 'lucide-react';
import { Note } from '../types';
import { Textarea } from './ui/Textarea';
import { Button } from './ui/Button';
export interface OrderNotesProps {
  notes: Note[];
  onAddNote: (content: string) => void;
}
export function OrderNotes({
  notes,
  onAddNote
}: OrderNotesProps) {
  const [newNote, setNewNote] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newNote.trim()) return;
    setIsSubmitting(true);
    await onAddNote(newNote);
    setNewNote('');
    setIsSubmitting(false);
  };
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };
  const sortedNotes = [...notes].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  return <div className="space-y-6" data-id="element-268">
      <form onSubmit={handleSubmit} className="bg-slate-50 border border-slate-200 rounded-lg p-4" data-id="element-269">
        <Textarea placeholder="Add a note or comment..." value={newNote} onChange={e => setNewNote(e.target.value)} rows={3} className="mb-3" data-id="element-270" />
        <div className="flex justify-end" data-id="element-271">
          <Button type="submit" variant="primary" disabled={!newNote.trim() || isSubmitting} data-id="element-272">
            Add Note
          </Button>
        </div>
      </form>

      {sortedNotes.length === 0 ? <div className="text-center py-12 bg-slate-50 rounded-lg border border-slate-200" data-id="element-273">
          <MessageSquareIcon className="w-12 h-12 mx-auto text-slate-400 mb-3" data-id="element-274" />
          <p className="text-slate-600" data-id="element-275">No notes yet</p>
        </div> : <div className="space-y-4" data-id="element-276">
          {sortedNotes.map(note => <div key={note.id} className="bg-white border border-slate-200 rounded-lg p-4" data-id="element-277">
              <div className="flex items-center justify-between mb-2" data-id="element-278">
                <span className="text-sm font-medium text-slate-900" data-id="element-279">
                  {note.author}
                </span>
                <span className="text-xs text-slate-500" data-id="element-280">
                  {formatDate(note.createdAt)}
                </span>
              </div>
              <p className="text-sm text-slate-700 whitespace-pre-wrap" data-id="element-281">
                {note.content}
              </p>
            </div>)}
        </div>}
    </div>;
}